import { useUiLanguage } from "@/i18n/useUiLanguage";
import { systemText, tr } from "@/i18n/copy";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { hasDirtyDrafts } from "@/lib/drafts";
import { TEAM_ROLES } from "@/teamRoles";

export default function StudioSwitcher({ showCreateStudio = false }) {
  useUiLanguage();
  const { studios = [], user, switchStudio } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (!["studio_owner","artist","front_desk","manager","agent_marketing"].includes(user?.role)) return null;
  if (studios.length < 2 && !showCreateStudio) return null;
  const change = async event => {
    const studio_id = event.target.value;
    if (studio_id === user.studio_id || busy) return;
    if (hasDirtyDrafts() && !window.confirm(tr("Hai modifiche non salvate. Vuoi cambiare Studio?"))) return;
    setBusy(true); setError("");
    try {
      if (!await switchStudio(studio_id)) setBusy(false);
    } catch (e) { setError(errMsg(e)); setBusy(false); }
  };
  return <div className="my-3 min-w-0">{studios.length > 1 && <label className="block text-xs text-muted-foreground">{tr("Studio attivo")}<select aria-label={tr("Studio attivo")} value={user.studio_id} onChange={change} disabled={busy} className="mt-1 w-full max-w-xs rounded-md border bg-background p-2 text-sm text-foreground">{studios.map(s => <option key={s.studio_id} value={s.studio_id}>{s.name} · {s.role === "studio_owner" ? tr("Titolare") : TEAM_ROLES.find(([r]) => r === s.role)?.[1] || s.role}</option>)}</select></label>}{showCreateStudio && <a href="/register?new-studio=1" className="mt-2 block text-xs text-muted-foreground underline underline-offset-4">{tr("Crea un altro Studio")}</a>}{error && <p role="alert" className="mt-1 text-xs text-destructive">{systemText(error)}</p>}{busy && <div role="status" className="fixed inset-0 z-[100] grid place-items-center bg-background/95">{tr("Apertura dello Studio…")}</div>}</div>;
}
